import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { fetchGymBenefitsData } from "../../../redux/hygiene-reducers/hygieneSlice";
import CommonStructured from "../../common-components/CommonStructured";
import { NoPic } from "../../../exports/Images";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import GymBenefitsForm from "./GymBenefitsForm";

const GymBenefits = ({ userInfoData, rowData }) => {
  const dispatch = useDispatch();
  const { gymBenefitsLoading, gymBenefits } = useSelector(
    (state) => state.hygiene
  );

  const [allDatas, setAllDatas] = useState([]);
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function closeModal() {
    setModValues(iniModvalues);
  }

  function getGymBenefits(gymId) {
    if (gymId) {
      dispatch(
        fetchGymBenefitsData({
          filters: { gym_id: gymId },
          token: userInfoData?.token,
        })
      );
    }
  }

  useEffect(() => {
    if (rowData?.user_id) {
      getGymBenefits(rowData.user_id);
    }
  }, [rowData?.user_id]);

  useEffect(() => {
    if (gymBenefits?.length > 0 && !gymBenefitsLoading) {
      setAllDatas(gymBenefits);
    } else {
      setAllDatas([]);
    }
  }, [gymBenefits, gymBenefitsLoading]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={closeModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        {modValues.modName === "manage_gym_benefits" ? (
          <GymBenefitsForm
            userInfoData={userInfoData}
            closeModal={closeModal}
            gymId={rowData?.user_id}
            gymName={rowData?.gym_name}
            rowData={allDatas}
            callFunction={() => getGymBenefits(rowData?.user_id)}
          />
        ) : null}
        {/* <div className={`createNewCTOModalContainer`}>
          <ModalHeadAndClose
            title={`${getReplace1(modValues.modName)}`}
            onClose={closeModal}
          />

          {modValues.modName === "manage_gym_benefits" ? (
            <GymBenefitsForm userInfoData={userInfoData} />
          ) : null}
        </div> */}
      </Modal>

      <CommonStructured
        pageHeading={"Gym Benefits"}
        createBtnTxt={"Manage Gym Benefits"}
        onClickCreateBtn={() =>
          setModValues((prevs) => ({
            ...prevs,
            isModOpen: true,
            modName: "manage_gym_benefits",
          }))
        }
        isReload={() => getGymBenefits(rowData?.user_id)}
      />

      {gymBenefitsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="gym-benefits-container mt30">
          {allDatas.map((benefit, index) => {
            return (
              <div className="gym-benefit-box" key={index}>
                <p className="gym-benefit-label">{benefit?.name || "NA"}</p>
                <div className="horizontal-gay-line"></div>
                <img
                  src={benefit?.image || NoPic}
                  alt={benefit?.name || "N/A"}
                  className="gym-benefit-image"
                />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default GymBenefits;
